
import React, { useState , useEffect } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Row, Col, FormGroup } from "reactstrap";
import { API_URL } from "../../constent";
import axios from "axios";
import {useHistory} from 'react-router-dom';

import {
    Block,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
  } from "../../components/Component";
const UpdateComparison = ({ match }) => {

    const [tableData, setTableData] = useState([]);
    const [savetable, setSavetable] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

     const comp_id = match.params.id;

     useEffect(() => {
        axios.get(`${API_URL}getcomparison/${comp_id}`).then((result)=>
        {
            console.log(result.data);
            setTableData(result.data);
            setSavetable(result.data);
            setLoading(false);
        })
    } , [])

      const addRow = () => {
        const newRow = new Array(tableData[0]?.length || 1).fill("");
        setTableData([...tableData, newRow]);
      };
    
      const addColumn = () => {
        const newTableData = tableData.map((row) => [...row, ""]);
        setTableData(newTableData);
      };
    
      const updateCell = (rowIndex, colIndex, value) => {
        const updatedTable = tableData.map((row, rIndex) =>
          row.map((cell, cIndex) =>
            rIndex === rowIndex && cIndex === colIndex ? value : cell
          )
        );

        console.log(updatedTable);
        setSavetable(updatedTable);
        setTableData(updatedTable);

      };
    
      const removeRow = (rowIndex) => {
        const updatedTable = tableData.filter((_, index) => index !== rowIndex);
        setTableData(updatedTable);
        setSavetable(updatedTable);
      };
    
      const removeColumn = (colIndex) => {
        const updatedTable = tableData.map((row) =>
          row.filter((_, index) => index !== colIndex)
        );
        setTableData(updatedTable);
        setSavetable(updatedTable);
        
      };

      const saveData = async () => {
        try {
          const response = await axios.post(`${API_URL}updatecomparison`, { savetable , comp_id });
          if (response.status === 200) {
            alert("Data Update successfully!");
            history.push(`/showcomparison/${comp_id}`);
          } else {
            alert("Error saving data!");
          }
        } catch (error) {
          console.error("Error saving data:", error);
          alert("Failed to save data.");
        }
      };

      if (loading) {
        return(
           <>
             <p>Loading....</p>
           </>
        ) 
    } 

    return(
        <React.Fragment>
        <Head title="Update Comparison"/>
            <Content page="component">

            <Block size="lg">
                <BlockHead>
                    <BlockHeadContent>
                    <BlockTitle tag="h5">Comparison Chart</BlockTitle>
                    </BlockHeadContent>
                </BlockHead>

                <Row className="g-gs">
                    <Col lg="12">
                    <table className="table table-bordered table-striped">
                        <tbody>
                        {tableData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                            {row.map((cell, colIndex) => (
                                <td key={colIndex}>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={cell}
                                    name={`inputdata[${rowIndex}][${colIndex}]`}
                                    onChange={(e) =>
                                    updateCell(rowIndex, colIndex, e.target.value)
                                    }
                                />
                                </td>
                            ))}
                            <td>
                                <button className="btn btn-info btn-sm" onClick={() => removeRow(rowIndex)}>Remove Row</button>
                            </td>
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colSpan={tableData[0]?.length || 1}>
                            <button className="btn btn-info btn-sm" onClick={addRow}>Add Row</button>&nbsp;&nbsp;
                            <button className="btn btn-info btn-sm" onClick={addColumn}>Add Column</button>&nbsp;&nbsp;
                            {tableData[0]?.length > 1 && (
                                <button className="btn btn-info btn-sm" onClick={() => removeColumn(tableData[0].length - 1)}>
                                Remove Last Column
                                </button> 
                            )}

                            &nbsp;&nbsp; <button className="btn btn-primary btn-sm" onClick={saveData}>
                            Update Data
                            </button>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                    </Col>
                </Row>
            </Block>
            </Content>
        </React.Fragment>
    )
}

export default UpdateComparison;